<template>
  <section class="order-attribution" aria-label="Marketing source" data-testid="order-attribution">
    <h2>Marketing source</h2>
    <dl class="order-attribution__fields">
      <div v-for="field in fields" :key="field.label" class="order-attribution__field">
        <dt>{{ field.label }}</dt>
        <dd>{{ field.value }}</dd>
      </div>
    </dl>
  </section>
</template>

<script>
// Every value came from a visitor's URL, so it is shown as text and never as a link.
const FIELDS = [
  { key: 'utm_source', label: 'Source' },
  { key: 'utm_medium', label: 'Medium' },
  { key: 'utm_campaign', label: 'Campaign' },
  { key: 'utm_term', label: 'Search term' },
  { key: 'utm_content', label: 'Ad content' },
  { key: 'click_id_type', label: 'Ad click type' },
  { key: 'click_id', label: 'Ad click ID' },
  { key: 'referrer', label: 'Came from' },
  { key: 'landing_page', label: 'Landing page' }
];

export default {
  name: 'OrderAttribution',
  props: {
    order: { type: Object, required: true }
  },
  computed: {
    fields() {
      const recorded = FIELDS
        .filter((field) => this.order[field.key])
        .map((field) => ({ label: field.label, value: this.order[field.key] }));

      return recorded.concat([{ label: 'Recorded', value: new Date(this.order.attribution_captured_at).toLocaleDateString() }]);
    }
  }
};
</script>

<style lang="scss" scoped>
.order-attribution h2 {
  margin-bottom: 8px;
  font-size: 14px;
}

.order-attribution__fields {
  margin: 0;
}

.order-attribution__field {
  display: flex;
  gap: 12px;
  padding: 2px 0;
  font-size: 13px;

  dt {
    flex: 0 0 110px;
    font-weight: 600;
  }

  dd {
    margin: 0;
    min-width: 0;
    overflow-wrap: anywhere;
  }
}
</style>
